import React, {useState, useEffect} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import styled from '@emotion/styled';
import useComponentVisible from '../../hooks/useComponentVisible';
import {logoutCustomer} from '../../utils/auth';

const MenuButton = styled.button`
	position: relative;

	padding: var(--space-10) var(--space-16);
	font-weight: 500;
	color: var(--color-gray-800);

	border-radius: 2.25rem;
	background-color: var(--color-white);
	box-shadow: inset 0 0 0 1px var(--color-gray-300);

	transition: background-color 0.3s ease-in-out;

	> img {
		margin-left: var(--space-6);
	}

	&:hover {
		background-color: var(--color-gray-100);
	}
	&:active {
		background-color: var(--color-gray-200);
	}
	a {
		color: var(--color-gray-800);
	}
`;
const LoginMenuWrapper = styled.div`
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 6.8rem;
	width: 14rem;
	right: 0;
	z-index: 1;
	padding: var(--space-10) 0;

	animation: slide-in 0.2s ease-out;

	color: var(--color-gray-800);
	background: var(--color-white);
	border-radius: var(--space-8);
	box-shadow: var(--shadow-base);
	button {
		padding: 0;
	}
	&.fade-out {
		animation: slide-out 0.2s ease-out;
	}
	@keyframes slide-in {
		0% {
			opacity: 0;
			transform: translateY(2rem);
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}
	@keyframes slide-out {
		0% {
			opacity: 1;
			transform: translateY(0);
		}
		100% {
			opacity: 0;
			transform: translateY(2rem);
		}
	}
`;
const LoginMenuContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: baseline;
	flex-grow: 1;
	padding-top: var(--space-8);
	padding-bottom: var(--space-8);

	a {
		width: 100%;
	}
`;

const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--color-gray-300);
	margin-bottom: var(--space-12);
`;

const UserDetails = styled.button`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	margin-bottom: var(--space-8);

	border-radius: var(--space-2);
	font-size: var(--font-16);
	font-weight: 400;

	.details {
		display: flex;
		flex-direction: column;

		border-radius: var(--space-2);
		> span:first-child {
			margin-bottom: var(--space-8);
			font-weight: 500;
		}
		> span:nth-child(2) {
			font-size: var(--font-14);
			color: var(--color-gray-600);
			margin-bottom: var(--space-16);
		}
	}
`;

const Spacer = styled.div`
	width: 100%;
	height: var(--space-8);
	pointer-events: none;
`;

const SpacerVertical = styled.div`
	height: 100%;
	width: var(--space-16);
`;

const AccountMenuButton = styled.div`
	display: flex;
	justify-content: flex-start;
	width: 100%;
	padding: var(--space-4) 0 !important;

	font-size: var(--font-16);
	
	font-weight: 500;
	border-radius: var(--space-2);
	&.sign-out {
		font-weight: 600;
		color: var(--company-dark);
	}
	img {
		margin-right: var(--space-12);
	}
`;

const LoginMenu = ({auth}) => {
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible,
    } = useComponentVisible(false);

    const history = useHistory();
    const location = useLocation();

    const signOut = () => {
        logoutCustomer();
        window.location.reload();
    };

    return (
        <MenuButton ref={ref} onClick={() => setIsComponentVisible(!isComponentVisible)}>
            {auth ? 'Hello, ' + auth.first_name : ''}
            <img src="/icons/chevron_down.svg"/>

            {isComponentVisible && (
                <LoginMenuWrapper className="menuTarget">
                    <SpacerVertical/>
                    <LoginMenuContainer>
                        <UserDetails to={'/profile'}>
                            <div className="details">
                                <span>{`${auth.first_name} ${auth.last_name}`}</span>
                                <span>{auth.email}</span>
                            </div>
                        </UserDetails>
                        <Divider/>
                        <Link to={'/profile'}>
                            <AccountMenuButton style={{pointerEvents: 'none'}}>
                                <img src="/icons/user.svg" alt="view profile icon"/>
                                View Profile
                            </AccountMenuButton>
                        </Link>
                        <Spacer/>
                        <Link>
                            <AccountMenuButton className="sign-out" onClick={() => signOut()}>
                                <img src="/icons/logout.svg" alt="logout icon"/>
                                Sign Out
                            </AccountMenuButton>
                        </Link>
                    </LoginMenuContainer>
                    <SpacerVertical/>
                </LoginMenuWrapper>
            )}
        </MenuButton>
    );
};

export default LoginMenu;
